// some of the SCBZ error messages are returned with
// html included so we try to strip that out here
export const htmlFilter = stringWithHtml =>
    stringWithHtml.replace(/<[^>]*>/g, '');
